import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Adiantamento } from '../types/Adiantamento.type';
import { ClasseAvaliacao } from '../types/ClasseAvaliacao.type';
import { Consumivel } from '../types/Consumivel.type';
import { Contrato } from '../types/Contrato.type';
import { ContratoTMA } from '../types/ContratoTMA.type';
import { Depreciacao } from '../types/Depreciacao.type';
import { Empresa } from '../types/Empresa.type';
import { Fornecedor } from '../types/Fornecedor.type';
import { GrupoMaterial } from '../types/GrupoMaterial.type';
import { Material } from '../types/Material.type';
import { Nota } from '../types/Nota.type';
import { NotaFiscal } from '../types/notafiscal.type';
import { Parcela } from '../types/Parcela.type';
import { PeriodoLiberado } from '../types/PeriodoLiberado.type';
import { Pesagem } from '../types/Pesagem.type';
import { Pesagem91p } from '../types/Pesagem91p.type';
import { Producao } from '../types/producao.type';
import { Provisao } from '../types/Provisao.type';
import { Provisao77p } from '../types/Provisao77p.type';
import { RequisicaoIntegracao } from '../types/RequisicaoIntegracao.type';

@Injectable({
  providedIn: 'root'
})
export class IntegradorService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getMateriais(){
    return this.httpClient.get<Material[]>(`${this.configService.getApiUrlRoot()}/materiais/`);
  }

  getFornecedores(){
    return this.httpClient.get<Fornecedor[]>(`${this.configService.getApiUrlIntegrador()}/fornecedor`);
  }

  getConsumiveis(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get<Consumivel[]> (`${this.configService.getApiUrlIntegrador()}/consumivel?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  getProducaos(){
    return this.httpClient.get<Producao[]> (`${this.configService.getWebApiUrlIntegrador()}/producao`)
  }

  getNotaFiscals(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get<NotaFiscal[]> (`${this.configService.getWebApiUrlIntegrador()}/notafiscal?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  postSolicitaNotaFiscal(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get(`${this.configService.getWebApiUrlIntegrador()}/notafiscal/sincronizar?instancias=${instancias}&dataInicio=${dataInicial}&dataFim=${dataFinal}`)
  }

  getIntegraNotaFiscal(corpo: any){
    return this.httpClient.post(`${this.configService.getWebApiUrlIntegrador()}/notafiscal/integrar`, corpo)
  }

  postIntegraNotaFiscalTaxa(corpo: any){
    return this.httpClient.post(`${this.configService.getWebApiUrlIntegrador()}/notafiscal/integrartaxa`, corpo)
  }

  getPesagens(){
    return this.httpClient.get<Pesagem[]> (`${this.configService.getWebApiUrlIntegrador()}/pesagem`)
  }

  sincronizarPesagens(){
    return this.httpClient.get<Pesagem[]> (`${this.configService.getApiUrlIntegrador()}/pesagem/ordens`)
  }

  getGruposMateriais(){
    return this.httpClient.get<GrupoMaterial[]>(`${this.configService.getApiUrlIntegrador()}/grupomaterial`)
  }

  getDepreciacoes(){
    return this.httpClient.get<Depreciacao[]>(`${this.configService.getApiUrlIntegrador()}/custo/depreciacao`)
  }

  postSolicitaDepreciacao(instancia: string, periodo: string){
    return this.httpClient.get(`${this.configService.getApiUrlIntegrador()}/custo/depreciacao/sincronizar?instancia=${instancia}&periodo=${periodo}`)
  }

  getNotas(){
    return this.httpClient.get<Nota[]>(`${this.configService.getWebApiUrlIntegrador()}/nota`);
  }

  getNota(id: string){
    return this.httpClient.get<Nota>(`${this.configService.getWebApiUrlIntegrador()}/nota/id?id=${id}`);
  }

  postNota(nota: Nota){
    return this.httpClient.post<Nota>(`${this.configService.getWebApiUrlIntegrador()}/nota/inserir`, nota);
  }

  putNota(nota: Nota){
    return this.httpClient.put<Nota>(`${this.configService.getWebApiUrlIntegrador()}/nota/alterar`, nota);
  }

  deleteNota(id: string){
    return this.httpClient.delete(`${this.configService.getWebApiUrlIntegrador()}/nota/${id}`);
  }

  getAdiantamentos(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get<Adiantamento[]> (`${this.configService.getWebApiUrlIntegrador()}/adiantamento?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  sincronizaAdiantamentos(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get<Adiantamento[]> (`${this.configService.getWebApiUrlIntegrador()}/adiantamento/sincronizar?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }


  integrarAdiantamentoERP(corpo: any){
    return this.httpClient.post(`${this.configService.getWebApiUrlIntegrador()}/adiantamento/integrarERP`, corpo)
  }

  getProvisoes(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get<Provisao[]> (`${this.configService.getApiUrlRoot()}/provisao/?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  sincronizaProvisoes(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/provisao/integracao/busca-pims?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  integrarProvisoes(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisao/integracao/integra-erp`, corpo);
  }

  getProvisoes77p(){
    return this.httpClient.get<Provisao77p[]>(`${this.configService.getWebApiUrlIntegrador()}/provisao77p`);
  }

  getProvisao77p(id: string){
    return this.httpClient.get<Provisao77p>(`${this.configService.getWebApiUrlIntegrador()}/provisao77p/id?id=${id}`);
  }

  postProvisao77p(provisao77p: Provisao77p){
    return this.httpClient.post<Provisao77p>(`${this.configService.getWebApiUrlIntegrador()}/provisao77p/inserir`, provisao77p);
  }

  putProvisao77p(provisao77p: Provisao77p){
    return this.httpClient.put<Provisao77p>(`${this.configService.getWebApiUrlIntegrador()}/provisao77p/alterar`, provisao77p);
  }

  deleteProvisao77p(id: string){
    return this.httpClient.delete(`${this.configService.getWebApiUrlIntegrador()}/provisao77p/${id}`);
  }

  getClassesAvaliacoes(){
    return this.httpClient.get<ClasseAvaliacao[]>(`${this.configService.getWebApiUrlIntegrador()}/classe-avaliacao`);
  }

  getClasseAvaliacao(id: string){
    return this.httpClient.get<ClasseAvaliacao>(`${this.configService.getWebApiUrlIntegrador()}/classe-avaliacao/id?id=${id}`);
  }

  postClasseAvaliacao(classeAvaliacao: ClasseAvaliacao){
    return this.httpClient.post<ClasseAvaliacao>(`${this.configService.getWebApiUrlIntegrador()}/classe-avaliacao/inserir`, classeAvaliacao);
  }

  putClasseAvaliacao(classeAvaliacao: ClasseAvaliacao){
    return this.httpClient.put<ClasseAvaliacao>(`${this.configService.getWebApiUrlIntegrador()}/classe-avaliacao/alterar`, classeAvaliacao);
  }

  deleteClasseAvaliacao(id: string){
    return this.httpClient.delete(`${this.configService.getWebApiUrlIntegrador()}/classe-avaliacao/${id}`);
  }

  getEmpresas(){
    return this.httpClient.get<Empresa[]>(`${this.configService.getWebApiUrlIntegrador()}/empresa`);
  }

  getPesagens91p(){
    return this.httpClient.get<Pesagem91p[]>(`${this.configService.getWebApiUrlIntegrador()}/pesagem91p`);
  }

  getPesagem91p(id: string){
    return this.httpClient.get<Pesagem91p>(`${this.configService.getWebApiUrlIntegrador()}/pesagem91p/${id}`);
  }

  postPesagem91p(pesagem: Pesagem91p){
    return this.httpClient.post<Pesagem91p>(`${this.configService.getWebApiUrlIntegrador()}/pesagem91p/inserir`, pesagem);
  }

  putPesagem91p(pesagem: Pesagem91p){
    return this.httpClient.put<Pesagem91p>(`${this.configService.getWebApiUrlIntegrador()}/pesagem91p/alterar`, pesagem);
  }

  deletePesagem91p(id: string){
    return this.httpClient.delete(`${this.configService.getWebApiUrlIntegrador()}/pesagem91p/${id}`);
  }

  getServicos(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get<Adiantamento[]> (`${this.configService.getWebApiUrlIntegrador()}/servico?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  sincronizaServicos(instancias: string, dataInicial: string | null, dataFinal: string | null){
    return this.httpClient.get<Adiantamento[]> (`${this.configService.getWebApiUrlIntegrador()}/servico/sincronizar?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }


  integrarServicosERP(corpo: any){
    return this.httpClient.post(`${this.configService.getWebApiUrlIntegrador()}/servico/integrarERP`, corpo)
  }

  getDespesasGeral(page: number, size: number, sortField: string, sortDirection: string, instancias: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getWebApiUrlIntegrador()}/custo/despesageral?page=${page}&size=${size}&instancias=${instancias}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  getDepreciacoesCusto(page: number, size: number, sortField: string, sortDirection: string, instancias: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getWebApiUrlIntegrador()}/custo/depreciacao?page=${page}&size=${size}&instancias=${instancias}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  getConsumo(page: number, size: number, sortField: string, sortDirection: string, instancias: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getWebApiUrlIntegrador()}/custo/consumo?page=${page}&size=${size}&instancias=${instancias}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  getHorasManutencao(page: number, size: number, sortField: string, sortDirection: string, instancias: string, dataInicio: string, dataFim: string){
    return this.httpClient.get<any>(`${this.configService.getWebApiUrlIntegrador()}/custo/horamanutencao?page=${page}&size=${size}&instancias=${instancias}&dataInicio=${dataInicio}&dataFim=${dataFim}`);
  }

  getPeriodosLiberadosCustos(instancia: string){

    return this.httpClient.get<PeriodoLiberado[]>(`${this.configService.getWebApiUrlIntegrador()}/custo/periodosLiberados?instancias=${instancia}`);
  }

  getProcessamentos(page: number, size: number, sortField: string, sortDirection: string, processos: string){

    return this.httpClient.get<any>(`${this.configService.getWebApiUrlIntegrador()}/processamento?page=${page}&size=${size}&processo=${processos}`);
  }


  postRequisicaoCustos(requisicao: RequisicaoIntegracao){
    return this.httpClient.post<ContratoTMA>(`${this.configService.getWebApiUrlIntegrador()}/custo/integracao`, requisicao);
  }

  getRetornoLiberadoCustos(instancia: string){

    return this.httpClient.get<PeriodoLiberado[]>(`${this.configService.getWebApiUrlIntegrador()}/custo/retornosLiberados?instancias=${instancia}`);
  }

  exportarNotaFiscal(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/notafiscal/exportar`, corpo, { responseType: 'blob'})
  }

  exportarProvisoes(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisao/relatorio/exportar`, corpo, { responseType: 'blob'})
  }

  exportarServicos(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/pagamento/exportarServicos`, corpo, { responseType: 'blob'})
  }

  exportarFornecedor(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/pagamento/exportarFornecedor`, corpo, { responseType: 'blob'})
  }

  exportarConsumiveis(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/consumivel/exportar`, corpo, { responseType: 'blob'})
  }



  postCancelarNF(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/notafiscal/cancelar`, corpo)
  }

  postEstornarNF(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/notafiscal/estornar`, corpo)
  }

  postCancelarFolha(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/pagamento/cancelarFolha`, corpo)
  }

  postEstornarFolha(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/pagamento/estornarFolha`, corpo)
  }

  postCancelarProvisao(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisao/cancelar`, corpo)
  }

  postEstornarProvisao(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisao/estornar`, corpo)
  }

  postCancelarServico(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/pagamento/servicos/cancelar`, corpo)
  }

  postEstornarServico(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/pagamento/servicos/estornar`, corpo)
  }

  postCancelarTaxa(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlIntegrador()}/notafiscal/cancelarTaxa`, corpo)
  }
}
